
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpimprichichwad() {



    const cardData =
    {
        keyword: 'Cab Service in Pimpri Chinchwad',
        heading: 'Platinum24 Cabs: Cab Service in Pimpri Chinchwad',
        headingDescription: ' Platinum24 Cabs provides dependable Cab Service in Pimpri Chinchwad, catering to residents, professionals, and students in one of Pune’s fastest-growing suburbs. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe, comfortable, and affordable rides for local commutes, airport transfers, and outstation journeys. With professional chauffeurs, timely pickups, and transparent fares, we make travel across PCMC stress-free and reliable. Whether you need a quick city ride, a corporate transfer, or a weekend trip, Platinum24 Cabs guarantees 24/7 availability, clean vehicles, and trustworthy cab services in Pimpri Chinchwad.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


         "services": [
    {
      "name": "Pimpri Chinchwad Cab Service",
      "description": "Experience seamless transportation with our Pimpri Chinchwad Cab Service, offering reliable and comfortable rides across the city. Whether you need a quick local trip or a longer journey, our fleet of well-maintained vehicles and professional drivers ensure a safe, punctual, and hassle-free travel experience tailored to your needs."
    },
    {
      "name": "Cab Booking Pimpri Chinchwad",
      "description": "Book your cab effortlessly in Pimpri Chinchwad through our easy online platform or phone service. Choose from a variety of vehicle options and schedule rides anytime, whether it’s for daily commutes, airport transfers, or weekend trips. Our quick and secure booking system guarantees timely pickups and smooth journeys."
    },
    {
      "name": "Taxi Service in Pimpri Chinchwad",
      "description": "Our Taxi Service in Pimpri Chinchwad offers versatile transportation solutions for individuals, families, and corporate clients. From local rides to outstation travel, enjoy competitive pricing, courteous drivers, and excellent customer support, making every ride pleasant and efficient."
    },
    {
      "name": "Pimpri Chinchwad Local Taxi",
      "description": "For all your local travel needs within Pimpri Chinchwad, our Local Taxi service provides convenient and affordable options. Whether commuting to work, shopping, or visiting friends, our cabs are available 24x7, ensuring prompt pickups and comfortable rides around the city."
    },
    {
      "name": "Affordable Cab Pimpri Chinchwad",
      "description": "Travel smart with our Affordable Cab service in Pimpri Chinchwad, designed to offer cost-effective rides without compromising on comfort or safety. Perfect for budget-conscious commuters and families looking for economical travel options within and outside the city."
    },
    {
      "name": "Pimpri Chinchwad Taxi with Driver",
      "description": "Enjoy the ease and safety of traveling with our Pimpri Chinchwad Taxi service that includes professional drivers familiar with the city’s routes and traffic conditions. Our courteous and trained drivers ensure timely pickups, smooth rides, and assistance whenever needed."
    },
    {
      "name": "Pimpri Chinchwad Outstation Cab",
      "description": "Plan your outstation trips with our reliable Pimpri Chinchwad Outstation Cab service. Whether it’s a weekend getaway, business trip, or family outing, our comfortable vehicles and experienced drivers provide hassle-free travel to destinations beyond Pimpri Chinchwad."
    },
    {
      "name": "Pimpri Chinchwad Airport Taxi",
      "description": "Catch your flights on time with our Pimpri Chinchwad Airport Taxi service. Available round the clock, we offer timely pickups and drop-offs at Pune Airport or other nearby airports, ensuring stress-free airport transfers with well-maintained vehicles and professional drivers."
    },
    {
      "name": "Cab Rental Pimpri Chinchwad",
      "description": "Rent cabs in Pimpri Chinchwad for short or long durations with our flexible Cab Rental service. Ideal for corporate events, family outings, or special occasions, our rental options come with competitive rates and the convenience of a dedicated driver for your trip."
    },
    {
      "name": "Cab Service Near Me Pimpri Chinchwad",
      "description": "Find and book reliable cab services near you in Pimpri Chinchwad with ease. Our extensive network ensures quick cab availability and prompt service wherever you are located in the city, providing convenience at your fingertips."
    },
    {
      "name": "Pimpri Chinchwad Taxi Deals",
      "description": "Take advantage of exclusive Pimpri Chinchwad Taxi Deals offering discounted rates on rides, packages for frequent travelers, and special offers on airport transfers and outstation trips. Save more while enjoying premium cab services."
    },
    {
      "name": "Pimpri Chinchwad City Taxi",
      "description": "Explore Pimpri Chinchwad city comfortably with our City Taxi service, perfect for sightseeing, business meetings, or daily errands. Our knowledgeable drivers guide you through the best routes, ensuring timely arrivals and enjoyable rides."
    },
    {
      "name": "Pimpri Chinchwad Corporate Cab",
      "description": "Our Corporate Cab service in Pimpri Chinchwad caters to businesses looking for efficient and professional employee transportation. We offer customized packages, bulk bookings, and dedicated support to meet your company’s travel needs with reliability and comfort."
    },
    {
      "name": "Pimpri Chinchwad Cab Booking Online",
      "description": "Book your Pimpri Chinchwad cabs online conveniently anytime and anywhere through our secure and user-friendly platform. Enjoy instant confirmations, easy cancellations, and 24x7 customer support for all your taxi booking needs."
    },
    {
      "name": "Pimpri Chinchwad Family Cab Service",
      "description": "Travel safely with your family using our Family Cab service in Pimpri Chinchwad. Spacious vehicles, child safety features, and courteous drivers make your family trips comfortable and worry-free, whether it’s for school runs, outings, or special occasions."
    }
  ],
  "tableData": [
    ["Pimpri Chinchwad Cab Service", "Cab Booking Pimpri Chinchwad"],
    ["Taxi Service in Pimpri Chinchwad", "Pimpri Chinchwad Local Taxi"],
    ["Affordable Cab Pimpri Chinchwad", "Pimpri Chinchwad Taxi with Driver"],
    ["Pimpri Chinchwad Outstation Cab", "Pimpri Chinchwad Airport Taxi"],
    ["Cab Rental Pimpri Chinchwad", "Cab Service Near Me Pimpri Chinchwad"],
    ["Pimpri Chinchwad Taxi Deals", "Pimpri Chinchwad City Taxi"],
    ["Pimpri Chinchwad Corporate Cab", "Pimpri Chinchwad Cab Booking Online"],
    ["Pimpri Chinchwad Family Cab Service", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Reliable Cab Service in Pimpri Chinchwad",
      "WhyChoosedescription": "Platinum24 Cabs offers prompt and trustworthy cab services across Pimpri Chinchwad for all your travel needs."
    },
    {
      "WhyChooseheading": "Quick and Convenient Pickup",
      "WhyChoosedescription": "Our drivers are available nearby to ensure minimal wait time and efficient pickups in Pimpri Chinchwad."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for your comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Local Routes",
      "WhyChoosedescription": "Our professional drivers know Pimpri Chinchwad well to provide smooth and timely rides."
    },
    {
      "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy transparent pricing inclusive of fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our support team is available around the clock to assist with your cab bookings and inquiries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
      "WhyChoosedescription": "Choose from hourly rentals, local rides, or long-distance outstation trips."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and comfort preferences."
    }
  ]























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Pimpri Chinchwad?',
        answer: 'Yes, Platinum24 Cabs provides reliable and convenient cab services throughout Pimpri Chinchwad for local travel and outstation trips.',
    },
    {
        question: 'How can I book a cab service in Pimpri Chinchwad with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Pimpri Chinchwad?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to meet your travel needs.',
    },
    {
        question: 'Can I book cabs for local travel and outstation trips from Pimpri Chinchwad?',
        answer: 'Yes, we provide both local and outstation cab services from Pimpri Chinchwad to destinations across Maharashtra and beyond.',
    },
    {
        question: 'Are your drivers experienced and professional in Pimpri Chinchwad?',
        answer: 'Absolutely. Our drivers are licensed, experienced, and familiar with Pimpri Chinchwad’s routes for safe and timely travel.',
    },
    {
        question: 'Can I book a cab for hourly local use in Pimpri Chinchwad?',
        answer: 'Yes, hourly rental packages are available for local travel within Pimpri Chinchwad and nearby areas.',
    },
    {
        question: 'Are safety and hygiene measures followed for cab services in Pimpri Chinchwad?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety protocols to protect our passengers.',
    },
    {
        question: 'Is cab service in Pimpri Chinchwad available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and service in Pimpri Chinchwad for your convenience.',
    },
    {
        question: 'What payment methods are accepted for cab bookings in Pimpri Chinchwad?',
        answer: 'We accept cash, digital payments, and card payments to make the booking process smooth and flexible.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Pimpri Chinchwad?',
        answer: 'Yes, you can specify any pickup and drop-off points within Pimpri Chinchwad as per your requirement.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ramesh Pawar',
        feedback: 'The cab service in Pimpri Chinchwad by Platinum24 Cabs was punctual and comfortable. Highly satisfied!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali More',
        feedback: 'Easy booking and great service for local travel in Pimpri Chinchwad. The driver was very professional.',
        rating: 5,
    },
];






























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const pimpriChinchwadCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Cab Service in Pimpri Chinchwad offering affordable local, outstation, airport, and corporate taxi services with experienced drivers.",
  "areaServed": {
    "@type": "Place",
    "name": "Pimpri Chinchwad"
  },
  "serviceType": [
    "Pimpri Chinchwad Cab Service",
    "Cab Booking Pimpri Chinchwad",
    "Taxi Service in Pimpri Chinchwad",
    "Pimpri Chinchwad Local Taxi",
    "Affordable Cab Pimpri Chinchwad",
    "Pimpri Chinchwad Taxi with Driver",
    "Pimpri Chinchwad Outstation Cab",
    "Pimpri Chinchwad Airport Taxi",
    "Cab Rental Pimpri Chinchwad",
    "Cab Service Near Me Pimpri Chinchwad",
    "Pimpri Chinchwad Taxi Deals",
    "Pimpri Chinchwad City Taxi",
    "Pimpri Chinchwad Corporate Cab",
    "Pimpri Chinchwad Cab Booking Online",
    "Pimpri Chinchwad Family Cab Service"
  ],
  "telephone": "+91-XXXXXXXXXX"
};







    return (
        <div>
<Helmet>
  <title>Cab Service in Pimpri Chinchwad | Affordable Taxi Booking Pimpri Chinchwad</title>
  <meta
    name="description"
    content="Reliable Cab Service in Pimpri Chinchwad offering affordable local, outstation, airport, and corporate taxi services with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pimpri Chinchwad Cab Service, Cab Booking Pimpri Chinchwad, Taxi Service in Pimpri Chinchwad, Pimpri Chinchwad Local Taxi, Affordable Cab Pimpri Chinchwad, Pimpri Chinchwad Taxi with Driver, Pimpri Chinchwad Outstation Cab, Pimpri Chinchwad Airport Taxi, Cab Rental Pimpri Chinchwad, Cab Service Near Me Pimpri Chinchwad, Pimpri Chinchwad Taxi Deals, Pimpri Chinchwad City Taxi, Pimpri Chinchwad Corporate Cab, Pimpri Chinchwad Cab Booking Online, Pimpri Chinchwad Family Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(pimpriChinchwadCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinpimprichichwad;